import { Col, Row, Tag } from 'antd'
import cx from 'classnames'
import _ from 'lodash'
import momentTz from 'moment-timezone'
import React from 'react'
import { I18n } from 'react-redux-i18n'
import { ShipmentStatuses } from '../../common/enums'

import { frameTheatreAddress } from '../../common/util/helper'
import '../../style/timeline.less'

class DCPInfo extends React.Component {
  getBasicInfo () {
    const {composition: {name}, theatre} = this.props
    const {shippingDetails: {trackingId, name: trackingName}} = theatre.dcp.details
    return (
      <div>
        <Row className='qw-mb-large'>
          <Col span={12}>
            <p
              className="qw-font-size-small qw-line-height-small qw-color-text-secondary-heading qw-bold">{I18n.t('compositions.theatre')}</p>
            <p
              className="qw-font-size-body qw-color-text-body qw-line-height-body qw-white-space-normal">{theatre.name}</p>
            <p
              className="qw-font-size-small qw-color-text-body qw-line-height-small qw-white-space-normal">{frameTheatreAddress(theatre)}</p>
          </Col>
          {(trackingId && trackingName) &&
          <Col span={12}>
            <p
              className="qw-font-size-small qw-line-height-small qw-color-text-secondary-heading qw-bold">{I18n.t('compositions.trackingInfo')}</p>
            <p
              className="qw-font-size-body qw-color-text-body qw-line-height-body qw-white-space-normal">{trackingName} &bull; {trackingId}</p>
          </Col>}
        </Row>
        <Row className='qw-mb-large'>
          <p
            className="qw-font-size-small qw-line-height-small qw-color-text-secondary-heading qw-bold">{I18n.t('compositions.name')}</p>
          <p
            className="qw-font-size-body qw-color-text-body qw-line-height-body qw-white-space-normal">{name}</p>
        </Row>
      </div>
    )
  }

  renderShipmentStatuses (status) {
    const className = cx('status-tag qw-mb-xxx-small', {
      'qw-warning': ShipmentStatuses.Pending === status,
      'qw-error': [ShipmentStatuses.AttemptFail, ShipmentStatuses.Exception].includes(status),
      'qw-success': ShipmentStatuses.Delivered === status,
      'qw-pending': [
        ShipmentStatuses.InfoReceived,
        ShipmentStatuses.InTransit,
        ShipmentStatuses.OutForDelivery
      ].includes(status),
      'qw-waiting': ShipmentStatuses.Expired === status
    })

    return <Tag className={className}>{I18n.t(`shipmentStatuses.${status}`)}</Tag>
  }

  renderTimeline () {
    const {shippingDetails: {trackingInfo: {checkpoints = []} = {}}} = this.props.theatre.dcp.details
    if (_.isEmpty(checkpoints)) {
      return null
    }

    return (
      <div className='qw-timeline'>
        {_.orderBy(checkpoints, ['checkpointTime'], ['desc']).map((checkpoint, idx) => {
          return (
            <div key={idx} className={cx('qw-timeline-item', {current: !idx})}>
              <div className='qw-timeline-left qw-font-size-small qw-line-height-small'>
                <p
                  className='qw-color-text-heading qw-mb-xx-small'>{this.convertCheckPointDate(checkpoint.checkpointTime, this.props.theatre.timezone)}</p>
                <p
                  className='qw-color-text-secondary-body'>{this.convertCheckPointTime(checkpoint.checkpointTime, this.props.theatre.timezone)}</p>
              </div>
              <div className='qw-timeline-right'>
                {this.renderShipmentStatuses(checkpoint.tag)}
                {checkpoint.message && <p className='qw-color-grey-1'>{checkpoint.message}</p>}
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  convertCheckPointDate (checkpointTime, timezone) {
    if (momentTz(checkpointTime, 'YYYY-MM-DDTHH:mm:ssZ', true).isValid()) {
      return momentTz(checkpointTime).tz(timezone).format('DD MMM YYYY')
    } else {
      const date = checkpointTime.includes('T') ? checkpointTime.split('T')[0] : checkpointTime
      return momentTz(date).endOf('day').format('DD MMM YYYY')
    }
  }

  convertCheckPointTime (checkpointTime, timezone) {
    if (momentTz(checkpointTime, 'YYYY-MM-DDTHH:mm:ssZ', true).isValid()) {
      return momentTz(checkpointTime).tz(timezone).format('hh:mmA')
    }
  }

  render () {
    return (
      <div className="dcp-info qw-mt-x-small">
        {this.getBasicInfo()}
        {this.renderTimeline()}
      </div>
    )
  }
}

export default DCPInfo



// WEBPACK FOOTER //
// ./src/app/components/compositions/DCPInfo.js